import { collapsedContainerClass, collapsedLinkClass, expandedLinkClass } from './constants';
import { writeExpansionStatusToStorage } from './write-expansion-status-to-storage';

export const collapseImageTiles = (showMoreColorsLink: HTMLElement, colorImageTileContainer: HTMLElement, productId: string) => {
    showMoreColorsLink.classList.remove(expandedLinkClass);
    showMoreColorsLink.classList.add(collapsedLinkClass);
    colorImageTileContainer.classList.add(collapsedContainerClass);
    writeExpansionStatusToStorage(productId, false);
};
